import { Component, OnInit,Injectable, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from '../../../environments/environment';

import { StorageService } from 'app/services/storage.service';
import { AuthWebService } from 'app/services/authweb.service';

@Component({
  selector: 'app-username',
  templateUrl: './username.component.html',
  styleUrls: ['./username.component.css']
})
export class UsernameComponent implements OnInit {
  params: any = {};
  loginUser: any = { };
	systemCode: String = null;

  constructor(private authWebservice: AuthWebService, private storageService: StorageService,
		private router: Router) { }

  ngOnInit() {
    this.systemCode = environment.authWebApi.systemCode
  }
  sendUsername(){
    
  }

}
